import { ApiStory } from "data/api/ApiStory";
import { trackEvent } from "services/frontend/Segment";


export function useRecordArticleRated(story: ApiStory) {

  return (rating: string) => {

    let category = "";
    for (let cat of story?.categories) {
      const isFirstCategory = category === "";
      category = `${isFirstCategory ? "" : " , "}${cat?.name ?? ""}`;
    }

    let user_rating = 1
    switch(true) {
        case rating === "meh":
            break;
        case rating === "good":
            user_rating = 2;
            break;
        case rating === "great":
            user_rating = 3;
            break;
        default:
            break;
    }

    trackEvent("Article Rated", {
      url: global?.window?.location?.href ?? "",
      author: story?.author?.fullName ?? "",
      category,
      article_title: story?.title ?? "",
      article_id: story?.id ?? "",
      user_rating
    });
  };
}
